
// Mutations
export const RESETGUILDS = 'RESETGUILDS';
export const BINDGUILDS = 'BINDGUILDS';
export const UNBINDGUILDS = 'UNBINDGUILDS';

// Actions
export const ADDGUILD = 'ADDGUILD';
export const SELECTGUILD = 'SELECTGUILD';

import db from '../../firebase/firebase'
import router from '../../router/router'
import {
  addBound,
  bindArray,
  removeBound,
  updateBoundObj } from '../helpers/binding';
import { localStorageSetKeyOrRemove } from '../../functions/general'
import {
  BINDDESTINATIONS,
  RESETDESTINATIONS,
  UNBINDDESTINATIONS } from './destinations'
import {
  RESETLOCKOUTS,
  UNBINDLOCKOUTCONTENT,
  UNBINDLOCKOUTS } from './lockouts'
import {
  BINDPROPERTIES,
  RESETPROPERTIES,
  UNBINDPROPERTIES } from './properties'
import { RESETSIGNUPS } from './signups';
import { RESETRAIDEVENTS } from './raidevents';
import { RESETTEAMS } from './teams';
import { RESETATTENDANCE } from './attendance';
import { RESETMEMBERS } from './members';
import { BINDPROPREQSETS, RESETPROPREQSETS, UNBINDPROPREQSETS } from './propreqsets';
import { BINDPLAYERPROPS, RESETPLAYERPROPS, UNBINDPLAYERPROPS } from './playerprops';
import { BINDCHARPROPS, RESETCHARPROPS, UNBINDCHARPROPS } from './charprops';
import { BINDCHARALTNAMES, RESETCHARALTNAMES, UNBINDCHARALTNAMES } from './charaltnames';

export default {
  state: () => ({
    guilds: [],
    selectedGuild: null,
  }),
  
  getters: {

  },

  mutations: {
    addBoundGuild: ( state, { snapshot, previousKey } ) => addBound( state.guilds, snapshot, previousKey ),
    removeBoundGuild: ( state, { snapshot } ) => removeBound( state.guilds, snapshot ),
    updateBoundGuild: ( state, { snapshot } ) => updateBoundObj( state.guilds, snapshot ),

    setSelectedGuild ( state, guild ) {
      state.selectedGuild = guild

      // Remember last selected guild in localStorage
      localStorageSetKeyOrRemove( 'lastSelectedGuild', guild )
    },

    [RESETGUILDS] ( state ) {
      state.guilds = []
      state.selectedGuild = null
    },
  },

  actions: {
    [BINDGUILDS] ( { commit } ) {
      const guildsRef = db.ref( 'guilds' ).orderByChild('name')
      bindArray( guildsRef, commit, 'Guild' )
    },
    [UNBINDGUILDS] ( { dispatch } ) {
      const guildsRef = db.ref( 'guilds' ).orderByChild('name')
      dispatch( 'resetState' )
      guildsRef.off()
    },

    [ADDGUILD] ( context, guild ) {
      return db.ref( 'guilds' ).push( guild );
    },
    
    async [SELECTGUILD] ( { commit, dispatch }, guild ) {
      await dispatch( UNBINDLOCKOUTCONTENT )
      await dispatch( UNBINDLOCKOUTS )
      await dispatch( UNBINDDESTINATIONS )
      await dispatch( UNBINDPLAYERPROPS )
      await dispatch( UNBINDCHARPROPS )
      await dispatch( UNBINDPROPREQSETS )
      await dispatch( UNBINDPROPERTIES )
      await dispatch( UNBINDCHARALTNAMES )

      if( !guild ) {
        commit( 'setSelectedDestination', null )
        commit( 'setSelectedLockout', null )
      }

      commit( RESETSIGNUPS )
      commit( RESETRAIDEVENTS )
      commit( RESETTEAMS )
      commit( RESETATTENDANCE )
      commit( RESETLOCKOUTS )
      commit( RESETDESTINATIONS )
      commit( RESETPROPREQSETS )
      commit( RESETPROPERTIES )
      commit( RESETPLAYERPROPS )
      commit( RESETCHARPROPS )
      commit( RESETMEMBERS )
      commit( RESETCHARALTNAMES )

      commit( 'setSelectedGuild', guild )

      if( guild ) {
        dispatch( BINDDESTINATIONS, guild )
        dispatch( BINDPROPERTIES, guild )
        dispatch( BINDPROPREQSETS, guild )
        dispatch( BINDPLAYERPROPS, guild )
        dispatch( BINDCHARPROPS, guild )
        dispatch( BINDCHARPROPS, guild )
        dispatch( BINDCHARALTNAMES, guild )
      }
      router.push( '/roster' )
    },

  },
}